import axios from "axios"
import { API_URL } from "../config"
import { toast } from "react-toastify"
import { authHeader } from "./auth-header"

const API = API_URL() + "api/"

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
	response => {
		return response
	},
	error => {
		if (error.response.status === 401) {
			toast.warning("Tu sesión ha expirado")
			localStorage.removeItem("ssid")
			setTimeout(() => {
				window.location = "/"
			}, 1000)
		} else {
			console.log(error)
		}
	}
)

const getVotacionesDisponibles = () => {
	const URL = API + "votaciones_disponibles"
	return axiosInstance
		.get(URL, authHeader())
		.then(({ data }) => data)
		.catch(error => console.log(error))
}

const getVotacionesHistorial = () => {
	const URL = API + "votaciones_historial"
	return axiosInstance
		.get(URL, authHeader())
		.then(({ data }) => data)
		.catch(error => console.log(error))
}

const sendVotos = (periodoId, votos) => {
	console.log(votos)
	const URL = API + "voto"
	const data = {
		periodo: periodoId,
		candidatos: votos
	}
	return axiosInstance
		.post(URL, data, authHeader())
		.then(({ data }) => data)
		.catch(error => error)
}

// TRICEL
const getVotacionesTricel = () => {
	const URL = API + "votaciones_tricel"
	return axiosInstance
		.get(URL, authHeader())
		.then(({ data }) => data)
		.catch(error => console.log(error))
}

const getResultadosVotacion = votacionId => {
	const URL = API + "resultados_votacion"
	return axiosInstance
		.post(URL, { periodo: votacionId }, authHeader())
		.then(({ data }) => data)
		.catch(error => console.log(error))
}

const getPadron = periodoId => {
	const URL = API + "padron_unidad"
	const data = {
		periodo: periodoId
	}
	return axiosInstance
		.post(URL, data, authHeader())
		.then(({ data }) => data)
		.catch(error => console.log(error))
}

const cerrarVotacion = periodoId => {
	const URL = API + "cerrar_votacion"
	const data = {
		periodo: periodoId
	}
	return axiosInstance
		.post(URL, data, authHeader())
		.then(({ data }) => data)
		.catch(error => console.log(error))
}

const saveUserTricel = (user, unidad) => {
	const URL = API + "tricel_create_user"
	const data = {
		run_user: user,
		unidad: unidad
	}
	return axiosInstance
		.post(URL, data, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

const getInforme = periodoId => {
	return axiosInstance({
		method: "post",
		url: API + "informe_resultado",
		responseType: "blob",
		data: { periodo: periodoId },
		headers: authHeader()["headers"]
	})
		.then(response => response)
		.catch(() => toast.error("No se ha podido descargar el archivo"))
}

const getInformePadron = periodoId => {
	return axiosInstance({
		method: "post",
		url: API + "padron_unidad/informe_padron",
		responseType: "blob",
		data: { periodo: periodoId },
		headers: authHeader()["headers"]
	})
		.then(response => response)
		.catch(() => toast.error("No se ha podido descargar el archivo"))
}

export {
	getVotacionesDisponibles,
	sendVotos,
	getVotacionesHistorial,
	getVotacionesTricel,
	getResultadosVotacion,
	getPadron,
	cerrarVotacion,
	saveUserTricel,
	getInforme,
	getInformePadron
}
